import { render, staticRenderFns } from "./navigation-desktop.vue?vue&type=template&id=acaa2a54&"
import script from "./navigation-desktop.vue?vue&type=script&lang=js&"
export * from "./navigation-desktop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports